module.exports = __webpack_public_path__ + "static/media/zolePlayed_1000000.59d58b0f.png";